import { thousandsSeparators } from 'currency-thousand-separator'

const renderAmount = (amount)=> {
    return thousandsSeparators(amount)
}

export default renderAmount;